import { useEffect, useState } from 'react';

export type FontSizeId = 'small' | 'standard' | 'large' | 'extra-large';

const FONT_SIZE_STORAGE_KEY = 'chatFontSize';
const FONT_SIZE_CSS_VAR = '--font-size-message';

export const FONT_SIZE_REM: Record<FontSizeId, string> = {
  small: '1.4rem',
  standard: '1.6rem',
  large: '1.8rem',
  'extra-large': '2rem',
};

const isFontSizeId = (value: string | null): value is FontSizeId => {
  return (
    value === 'small' ||
    value === 'standard' ||
    value === 'large' ||
    value === 'extra-large'
  );
};

const getStoredFontSize = (): FontSizeId => {
  const fontSize = localStorage.getItem(FONT_SIZE_STORAGE_KEY);

  return isFontSizeId(fontSize) ? fontSize : 'standard';
};

const applyFontSize = (fontSize: FontSizeId): void => {
  document.documentElement.style.setProperty(
    FONT_SIZE_CSS_VAR,
    FONT_SIZE_REM[fontSize],
  );
};

export const useFontSize = () => {
  const [fontSize, setFontSizeState] = useState<FontSizeId>(getStoredFontSize);

  useEffect(() => {
    applyFontSize(fontSize);
  }, [fontSize]);

  const setFontSize = (nextFontSize: FontSizeId) => {
    localStorage.setItem(FONT_SIZE_STORAGE_KEY, nextFontSize);
    setFontSizeState(nextFontSize);
  };

  return { fontSize, setFontSize };
};
